/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
import type { FeedbackRequest } from '../models/FeedbackRequest';
import type { UploadUrlResponse } from '../models/UploadUrlResponse';

export class FeedbackService {
  /**
   * Send feedback
   * Send feedback to the development team using a web hook to send it to MS Teams. Include a screenshot for visual reference.
   * @param xSelectedOrganisationId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static sendFeedback(xSelectedOrganisationId: string, requestBody: FeedbackRequest): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/feedback',
      headers: {
        'X-Selected-Organisation-Id': xSelectedOrganisationId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `An error occurred caused by invalid content sent to our application.`,
        401: `Not authorized to see this content`,
        500: `Some unexpected error occurred, probably caused by either a configuration error or a programming mistake. Please contact the development team!`,
      },
    });
  }

  /**
   * Upload feedback attachment
   * Upload an attachment to be used in feedback. The returned URL can be used in the feedback request.
   * @param xSelectedOrganisationId
   * @param formData
   * @returns UploadUrlResponse OK
   * @throws ApiError
   */
  public static uploadFeedbackAttachment(
    xSelectedOrganisationId: string,
    formData: {
      file?: Blob;
    }
  ): CancelablePromise<UploadUrlResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/feedback/attachment',
      headers: {
        'X-Selected-Organisation-Id': xSelectedOrganisationId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `An error occurred caused by invalid content sent to our application.`,
        401: `Not authorized to see this content`,
        500: `Some unexpected error occurred, probably caused by either a configuration error or a programming mistake. Please contact the development team!`,
      },
    });
  }
}
